module.exports = __webpack_public_path__ + "img/hamburguesa_pollo.8e688755.jpeg";